import {
	Card,
	CardBody,
	Input,
	Table,
	TableCell,
	TableContainer,
	TableHeader,
	Button,
} from '@windmill/react-ui';
import MenuDrawer from 'components/drawer/MenuDrawer';
import MainDrawer from 'components/drawer/MainDrawer';
import MenuTable from 'components/menu/MenuTable';
import NotFound from 'components/table/NotFound';
import PageTitle from 'components/Typography/PageTitle';
import useAsync from 'hooks/useAsync';
import useFilter from 'hooks/useFilter';
import { useState, useEffect, useContext } from 'react';
import MenuServices from 'services/MenuServices';
import sidebar from 'routes/sidebar';
import DataWrapper from './DataWrapper';
// import MenuDrawer from "components/drawer/MenuDrawer";
import { FiRefreshCcw } from 'react-icons/fi';
import DeleteModal from 'components/modal/DeleteModal';
import useToggleDrawer from 'hooks/useToggleDrawer';
import { SidebarContext } from 'context/SidebarContext';
import { FiPlus } from 'react-icons/fi';

const Menu = () => {
	const adminInfo = localStorage.getItem('adminInfo')
		? JSON.parse(localStorage.getItem('adminInfo'))
		: null;
	const { data, loading, error } = useAsync(MenuServices.getAllMenu);
	//const menu = data?.data || [];
	// const [loading, setLoading] = useState(false);
	const { toggleDrawer, setIsUpdate } = useContext(SidebarContext);
	const { title, serviceId } = useToggleDrawer();
	const [itemsPerPage, setItemsPerPage] = useState(10);
	const [tab] = useState(0);
	const [menuData, setMenuData] = useState([]);
	const [status, setStatus] = useState('');
	useEffect(() => {
		if (data?.status) {
			setStatus(data.status);
		} else {
			setStatus(false);
		}
	}, [data?.status]);
	const { menuRef, dataTable, serviceData, handleSubmitMenu, currentPage } =
		useFilter(menuData, itemsPerPage);

	useEffect(() => {
		if (serviceData.length !== 0) {
			setItemsPerPage(serviceData.length);
		}
	}, [serviceData]);

	useEffect(() => {
		if (data) {
			const responseData = data?.data || [];
			if (Array.isArray(responseData)) {
				const updatedData = responseData.map(
					({
						id_menu,
						id_parent,
						name,
						position,
						id_sub_parent,
						sub_parent_name,
						...rest
					}) => ({
						id_menu,
						id_parent,
						name,
						position,
						id_sub_parent,
						sub_parent_name,

						...rest,
					})
				);
				setMenuData(updatedData);
			} else {
				console.error('Expected an array but got:', responseData);
			}
		} else {
			console.error('Data is null or undefined');
		}
	}, [data]);

	const isAdmin = adminInfo?.id === 1;

	const hideView = isAdmin
		? true
		: adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'add menu' && perm.view === 1
		  );

	const hideDelete = isAdmin
		? true
		: adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'add menu' && perm.delete === 1
		  );

	const hideEdit = isAdmin
		? true
		: adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'add menu' && perm.edit === 1
		  );

	const hideAdd = isAdmin
		? true
		: adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'add menu' && perm.add === 1
		  );

	const handleRefresh = () => {
		setIsUpdate(true);
	};

	return (
		<>
			{hideView && (
				<>
					<DeleteModal id={serviceId} title={title} />
					<MainDrawer>
						<MenuDrawer id={serviceId} />
					</MainDrawer>
					<PageTitle sidebar={sidebar().sidebar} />

					<Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800 mb-5">
						<CardBody>
							<div className="flex gap-6 items-center">
								<div className="flex-1">
									<Input
										ref={menuRef}
										className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
										type="search"
										name="search"
										placeholder="Quick Search"
										autoComplete="off"
										onChange={handleSubmitMenu}
									/>
								</div>

								{hideAdd && (
									<Button
										onClick={toggleDrawer}
										className="w-56 rounded-md h-10"
									>
										<span className="mr-3">
											<FiPlus />
										</span>
										Add Menu
									</Button>
								)}

								<FiRefreshCcw
									onClick={() => {
										handleRefresh();
									}}
									cursor="pointer"
								/>
							</div>
						</CardBody>
					</Card>

					<DataWrapper loading={loading} error={error} status={status}>
						{serviceData?.length !== 0 ? (
							<TableContainer>
								<div
									className="overflow-y-scroll"
									style={{ maxHeight: '67vh', scrollbarWidth: 'thin' }}
								>
									<Table>
										<TableHeader className="custom-table-header capitalize z-10 text-center sticky top-0 text-sm">
											<tr>
												<TableCell>Sl.No.</TableCell>
												<TableCell>Parent Name </TableCell>
												<TableCell>Sub Parent</TableCell>
												<TableCell>Name</TableCell>
												<TableCell>Position</TableCell>
												<TableCell>Path</TableCell>
												<TableCell>Active/Inactive</TableCell>
												<TableCell>Actions</TableCell>
											</tr>
										</TableHeader>
										<MenuTable
											menu={dataTable}
											perpage={itemsPerPage}
											currentPage={currentPage}
											tab={tab}
											hideDelete={hideDelete}
											hideEdit={hideEdit}
										/>
									</Table>
								</div>
							</TableContainer>
						) : (
							<NotFound title="There are no menus." />
						)}
					</DataWrapper>
				</>
			)}
		</>
	);
};

export default Menu;
